import * as Headless from '@sail/theme-headless';
import {css, theme, withOpacity} from '../theme';

export const Popover = theme(Headless.Popover, [
  css({
    background: 'surface',
    border: css.value('1px solid'),
    borderColor: 'neutral',
    borderRadius: 'medium',
    boxShadow: css.value(
      `0px 5px 15px 0px rgb(0 0 0 / 8%), 0px 15px 35px 0px ${withOpacity(
        '$color.neutral700',
        '12%',
      )}`,
    ),
  }),
]);
